const isQA = process.env.REACT_APP_ENV_QA;

const baseUrls = {
  actionIdentifiers: "/api/external-requests/action-metadata",
  charts: "/api/charts",
  chatbot: "/api/chatbot",
  cropVarieties: "/api/fields/crop-varieties",
  consents: "/api/user-consents",
  equipments: "/api/users/equipment",
  externalRequests: "/api/external-requests",
  fieldList: "/api/fields/users",
  fields: "/api/fields/fields",
  filters: "/api/users/user-filters",
  fieldSearch: "/api/fields/search",
  joinRequests: "/api/fields/join-requests",
  labels: "/api/users/labels",
  machineryInfrastructure: "/api/machinery-infrastructure",
  messaging: "/api/messaging",
  newsFeed: "/api/external-requests/content",
  notifications: "/api/notifications/my-settings",
  inbox: "/api/notifications/my-inbox",
  invoices: "/api/invoices",
  opekepe: "/api/opekepe",
  payments: "/api/payments",
  opekepeAuth: "/api/socials/auth/opekepe",
  redoc: "/api/redoc",
  satellite: "/api/external-requests/satellite-api/api",
  schema: "/api/schema",
  search: "/api/search",
  socials: "/api/socials",
  soilComposition: "/api/fields/soil-composition",
  statistics: "/api/external-requests/statistics",
  statisticsV2: "/api/external-requests/statistics-api",
  superset: "/api/superset/dashboards/spd/",
  swagger: "/api/swagger",
  auth: "/api/authentication/jwt/token",
  users: "/api/users",
  wateringMechanism: "/api/fields/watering-mechanism",
  waterUsageLimits: "/api/fields/water-usage-limits",
  weather: "/api/external-requests/weather-analytics",
  weatherHistorical: "/api/external-requests/weather-analytics/historical",
  weatherForecast: "/api/external-requests/weather-analytics/forecast",
};

const qaUrls = baseUrls;

const prodUrls = baseUrls;

export const URLS = isQA ? qaUrls : prodUrls;

export const constructURL = (base, url) => {
  if (!base) {
    return "/";
  }

  const clearedBase = base.endsWith("/") ? base.slice(0, -1) : base;

  if (!url) {
    return `${clearedBase}/`;
  }

  const clearedUrl = url.replace(/^\/+|\/+$/g, "");

  return `${clearedBase}/${clearedUrl}/`;
};
